import { render, staticRenderFns } from "./Factoring.vue?vue&type=template&id=1d1a80c2&scoped=true&"
import script from "./Factoring.vue?vue&type=script&lang=js&"
export * from "./Factoring.vue?vue&type=script&lang=js&"
import style0 from "./Factoring.vue?vue&type=style&index=0&id=1d1a80c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1a80c2",
  null
  
)

export default component.exports